import { render, staticRenderFns } from "./DocumentDownloadsLink.vue?vue&type=template&id=08ec81e4&scoped=true"
var script = {}
import style0 from "./DocumentDownloadsLink.vue?vue&type=style&index=0&id=08ec81e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec81e4",
  null
  
)

export default component.exports